import { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { setSelectedItem } from "../redux-state/features/orderState";
import axios from "axios";
import urls from "../urls";
class ItemsSelect extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      isLoading: false,
      options: [
        { value: "123", label: "ورق أبيض", available_quantity: 40 },
        { value: "124", label: "قلم سبورة", available_quantity: 100 },
        { value: "125", label: "جهاز كمبيوتر ", available_quantity: 4 },
      ],
    };
    this.placeholder = "إختيار السلعة ... ";
  }
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios.get(urls.getStore(faculty_id)).then((res) => {
      const options = res.data.results.map((obj) => ({
        value: obj.item_id,
        label: obj.item_name,
        available_quantity: obj.quantity,
      }));
      this.setState({ options });
    });
  }
  noOptionsMessage = () => "لا توجد نتائج ";
  handleChange = (obj) => {
    this.props.setSelectedItem(obj);
    console.log(obj);
  };
  render() {
    const { options, isLoading } = this.state;
    return (
      <div>
        <Select
          isRtl
          options={options}
          isSearchable
          isLoading={isLoading}
          placeholder={this.placeholder}
          noOptionsMessage={this.noOptionsMessage}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

const mapDispatchToProps = { setSelectedItem };
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ItemsSelect);
